import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { openExtraModal,closeExtraModal,openTermsModal, closeTermsModal, closeAllModals } from '../../actions/modals.js';
import { getPricing, PaypalPaidSuccess,postPayStripe, CheckCoupon,updateCouponCode, BothEmailsMatch, BothEmailsDontMatch, TermsAreChecked, updateBalanceUsed } from '../../actions/pay.js';
import { updateStep3, getSession1, removeExtra, upsell_time_limit,downsell_time_limit,downsell_editor_level, upsell_editor_level, updatePaperInput } from '../../actions/paper.js';
import { validateEmail, invalidateEmail, updateUserEmail } from '../../actions/user.js';
import Extras from './Extras.js';
import calculatePrice from '../../util/calculatePrice';
import { getExtraPrice } from '../../util/calculatePrice';
import { trackPage } from '../../util/analytics.js';
import * as displayUtils from '../../util/displayUtils';
import { emailValidator } from '../../util/validators';
import PaypalExpressBtn from 'react-paypal-express-checkout';
import StripeCheckout from 'react-stripe-checkout';
import Terms from './Terms.js';
import TopNav from '../includes/TopNav';
import Footer from '../pages/Footer.js';
import {Helmet} from "react-helmet";
import * as config from '../../config/config';
import Bubbles from './Bubbles';

const client = {
  sandbox: 'AeWYllICUwQsHzpqxgGeT6GqV8mLA9_32taSv1OqogcnOvO6GKHEjYKXVT0VueDW7g6QAK81TVpoK9hh', // Joel's sandbox client ID
  production: 'AWf68kkLngskcliqUEP1Bk_7LUlkBvTc3zunF5acRep5IQUoow181HRz1Bz3vARjK1D04wdoXjjw5HEM', // To Be Replaced with Joel's production...
}
const paypalEnv = config.PAYPAL_ENV;

class Step4Page extends Component{
  constructor(props) {
    super(props);
    this.state = { 
      'showStripeCustomErrorMessage': false,
      'paymentProcessing': false,
      'usingBalance': false,
      'showCouponModal': false,
      'couponModalMsg': '',
      'paypalAvailable': false
    };
    this.step2Selection = {
      editor_level: this.props.Paper.paper.editor_level,
      time_limit: this.props.Paper.paper.time_limit
    };
    this.props.dispatch(getPricing());
    this.props.dispatch(getSession1(function(){
      var data = calculatePrice(this.props.Paper);
      if(window.localStorage.getItem('refCode')) {
        this.props.dispatch(updateCouponCode(window.localStorage.getItem('refCode')));
        this.CheckCoupon()
      } 
      if(this.props.Paper.paper.email) {
        this.props.dispatch(updateUserEmail(this.props.Paper.paper.email));
      }
      this.step2Selection = {
        editor_level: this.props.Paper.paper.editor_level,
        time_limit: this.props.Paper.paper.time_limit
      };
    }.bind(this)));

    this.undoEditorClicked = false;
    this.undoTimeClicked = false;
    this.validateEmail = this.validateEmail.bind(this);
    this.emailFieldOpts = {};
    this.props.Pay.emails_match = true;

    this.stripeKeys = {
      'test': 'pk_test_edY38YODJB9Vo8Gy0T8U3bY300BnqFUf4m',
      'live': 'pk_live_QGBKvJeasSRIHQREDn1dkH3Y'
    };
    this.stripeEnv = config.STRIPE_ENV;

  }
  CheckCoupon(e, b){
    var emailValue = null;
    if(this.props.User.email) {
      emailValue = this.props.User.email;
    } else if (this.props.Paper.paper.user_email) {
      emailValue = this.props.Paper.paper.user_email;
    } else if (this.props.Paper.paper.email) {
      emailValue = this.props.Paper.paper.email;
    }

    this.props.dispatch(CheckCoupon({
      'coupon_code' : this.props.Pay.coupon_code,
      'word_count' : this.props.Paper.paper.word_count,
      'email': emailValue
    }, function(data){
      var stateUpdate = {'showCouponModal': true};

      if(data.amount === false) {
        if(window.localStorage.getItem('refCode')) {
          // removing ref code from local storage as it is invalid
          window.localStorage.removeItem('refCode');
        }
        stateUpdate.couponModalMsg = data.msg;
      } else if(data.is_affiliate) {
        stateUpdate.couponModalMsg = "You have received a discount of $"+data.amount+" because your friend referred you. It has been already deducted from your order.";
      } else {
        stateUpdate.couponModalMsg = "This coupon is valid! You have saved $" + data.amount + " off the cost of your edit.";
      }
      this.setState(stateUpdate);
    }.bind(this)));
  };
  // callback when stripe is done
  onStripeToken = (token) => {
      window.localStorage.removeItem('refCode');
      this.setState({'paymentProcessing': true});
      let payobj = {
          paper : this.props.Paper.paper,
          tax: this.taxValue,
          charged_amount: this.final_price,
          charge: token,
          coupon: { 
            code: this.props.Pay.coupon_code,
            amount: this.props.Pay.coupon_amount,
            is_affiliate: this.props.Pay.is_affiliate_code
          },
          usedBalance: this.props.Pay.balanceUsed
      };
      if(!payobj.paper.email && this.props.User.email) {
        payobj.paper.email = this.props.User.email;
      } 
      this.props.dispatch(postPayStripe(payobj, function(result) {
        if(result) {
          if(window.woopra != 'undefined') {
            window.woopra.track("payment", {
              amount: this.props.Paper.paper.doc_cost,
              currency: "USD"
            });
          }
          window.clickcease(this.props.Paper.paper.doc_cost);
          this.props.history.push('/thankyou/');
          window.scrollTo(0, 0);
        } else {
          this.setState({
            'showStripeCustomErrorMessage': true,
            'paymentProcessing': false
          });
        }
      }.bind(this)));
  };
  onStripeClosed() {
    //this.setState({'paymentProcessing': true});
  }
  componentDidMount() {
    trackPage('step4');
    console.log("checking is user is logged IN");
    console.log(this.props.User);
    if(this.props.User.loggedin) {
      console.log("setting to readonly!!");
      this.emailFieldOpts['readOnly'] = 'readOnly';
    }
    console.log("dispatching emails match to make sure we're set");
    this.props.dispatch(function(){
      return function(dispatch) {
        console.log("this is called");
        dispatch(BothEmailsMatch());
      }
    });
    // email must be valid if it comes from an active session
  }
  componentDidUpdate(){
  }
  updateCouponCode(e){
    this.props.dispatch(updateCouponCode(e.target.value));
  };
  updateUsingBalance(balanceUsed, e) {
    if(!this.state.usingBalance) {
      this.props.dispatch(updateBalanceUsed(balanceUsed));
      this.setState({'usingBalance': true});
    } else {
      this.props.dispatch(updateBalanceUsed(0));
      this.setState({'usingBalance': false});
    }
    
  }
  TermsAreChecked(e){
    this.props.dispatch(TermsAreChecked(this.props.Pay.terms_accepted));
  };
  validateEmail(e){
    //this.props.User.email = e.target.value;
    this.props.dispatch(updateUserEmail(e.target.value));
    console.log("validating on "+e.target.value);
    // TODO - change state dispatcher to alter a different state prop
    if(emailValidator(e.target.value)){
      this.props.dispatch(BothEmailsMatch(this.props.User.email, e.target.value));
      this.props.dispatch(updatePaperInput('email', e.target.value));
    } else {
      this.props.dispatch(BothEmailsDontMatch(this.props.User.email, e.target.value));
    }
  }
  CheckBothEmails(e){
    if(e.target.value === this.props.User.email){
      this.props.dispatch(BothEmailsMatch(this.props.User.email, e.target.value));
    }else {
      this.props.dispatch(BothEmailsDontMatch(this.props.User.email, e.target.value));
    }
  };
  openExtraModal(e){
    this.props.dispatch(openExtraModal());
  };
  openTermsModal(e){
    this.props.dispatch(openTermsModal());
  };
  closeExtraModal(e){
    this.props.dispatch(closeExtraModal());
  };
  closeTermsModal(e){
    this.props.dispatch(closeTermsModal());
  };
  closeAllModals(e){
    this.props.dispatch(closeAllModals());
  };
  updatePaperInput(key, e){
    if(e.target){
      this.props.dispatch(updatePaperInput(key, e.target.value));
    }
    var data = calculatePrice(this.props.Paper);
  };
  timeoutPaypal() {
    var that = this;
    setTimeout(function() {
      that.showPaypal();
    }, 15000)
  }
  showPaypal() {
    this.setState({paypalAvailable: true});
  }
  removeExtra(e, extra, i){
    console.log(extra)
    console.log(e)
    this.props.dispatch(updateStep3(e, this.props.Paper.paper.extras));
    var data = calculatePrice(this.props.Paper);
  };
  upsell_time_limit(new_time_limit){
    if(this.undoTimeClicked)
    {
      this.undoTimeClicked = false;
      return; // skip double call through render
    }
    if(this.props.Paper.paper.time_limit != "1.5"){
      this.props.dispatch(upsell_time_limit(new_time_limit));
      var data = calculatePrice(this.props.Paper);
    }
  };
  downsell_time_limit(e){
    this.undoTimeClicked = true;
    var new_time_limit = this.step2Selection.time_limit;
    this.props.dispatch(downsell_time_limit(new_time_limit));
    var data = calculatePrice(this.props.Paper);
  };
  downsell_editor_level(e){
    this.undoEditorClicked = true;
    var new_editor_level = this.step2Selection.editor_level;
    this.props.dispatch(downsell_editor_level(new_editor_level));
    var data = calculatePrice(this.props.Paper);
    return false;
  };
  upsellEditorLevel(new_editor_level){
    if(this.undoEditorClicked)
    {
      this.undoEditorClicked = false;
      return; // skip double call through render
    }
    console.log("gonen - editor upsell called with "+new_editor_level);
    if(this.props.Paper.paper.editor_level != "pro"){
      this.props.dispatch(upsell_editor_level(new_editor_level));
      var data = calculatePrice(this.props.Paper);
    }
  };

  getAcceptRequiredClasses(what) {
    var styles = {};
    var returnRed = false;
    // newState.paper.country && newState.paper.address && newState.paper.zip_code
    if(what == 'address' && !this.props.Paper.paper.address) {
      returnRed = true;
    }
    if(what == 'state') {
      styles['border'] = '1px solid rgb(172,172,172)';
      styles['borderColor'] = 'rgb(172,172,172)';
      styles['height'] = '24px';
      styles['paddingLeft'] = '9px';
      styles['fontSize'] = '10px';
      styles['color'] = '#6E6E6E';
      if(!this.props.Paper.paper.country) {
        returnRed = true;
      }
    }
    if(what == 'zip' && !this.props.Paper.paper.zip_code) {
      returnRed = true;
    }

    if(what == 'terms' && !this.props.Pay.terms_accepted) {
      returnRed = true;
      //styles['WebkitAppearance'] = 'none';
      styles['boxShadow'] = 'none !important';
      styles['outline'] = '1px solid #ff0000';
      styles['outlineOffset'] = '-1px';
      styles['border'] = 'none';
    }
    if(what == 'terms') {
      styles['marginRight'] = '5px';
    }
    if(what == 'email' && !this.props.Pay.emails_match) {
      returnRed = true;
    }
    if(returnRed && what != 'terms') {
      styles['borderColor'] = '#ff0000';
    }
    return styles;
    
  }
  closeCouponModal() {
    this.setState({'showCouponModal': false});
  }
  getExtrasSummary() {
    return (
      <div className="wrap extras-added">
        <div className="extras-added-list">
          {this.props.Paper.paper.extras.map(function(extra, i){
            return(
              <div className="extras-added-item has_tooltip">
                <div className="remove" onClick={this.removeExtra.bind(this, extra, i)}>
                <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Step-4" transform="translate(-909.000000, -381.000000)" stroke="#DA5757">
                            <g id="Group-8" transform="translate(910.000000, 372.000000)">
                                <g id="Group-11">
                                    <g id="Group-10" transform="translate(0.000000, 10.000000)">
                                        <circle id="Oval-1" cx="11.5" cy="11.5" r="11.5"></circle>
                                        <g id="Group-16" transform="translate(8.000000, 8.000000)" strokeLinecap="square">
                                            <path d="M0.378600823,6.97707231 L7.20113782,0.15453531" id="Line"></path>
                                            <path d="M0.378600823,6.97707231 L7.20113782,0.15453531" id="Line-Copy-9" transform="translate(3.786008, 3.569665) scale(-1, 1) translate(-3.786008, -3.569665) "></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg></div>
                <p className="item_info">{extra.charAt(0).toUpperCase() + extra.slice(1)} <span className="label-value">${getExtraPrice(this.props.Paper.paper.extras, this.props.Paper.paper.word_count, 0, extra)}</span></p>
              </div>
            )
          }, this)}
        </div>
        <div className="extras-added-button">
          <button className="button add_extras" onClick={this.openExtraModal.bind(this)}>Add more Extras</button>
        </div>
      </div>
    )
  }
  render() {
    console.log(this.step2Selection);
    const onSuccess = (payment) => {
      console.log("payment object returned from paypal:");
      console.log(payment);
        window.localStorage.removeItem('refCode');
        var send_ob = {
          payment: payment,
          paper: this.props.Paper.paper,
          charged_amount: this.final_price,
          tax: this.taxValue,
          coupon: {
            code: this.props.Pay.coupon_code,
            amount: this.props.Pay.coupon_amount,
            is_affiliate: this.props.Pay.is_affiliate_code
          },
          usedBalance: this.props.Pay.balanceUsed
        }
        if(!send_ob.paper.email && this.props.User.email) {
          send_ob.paper.email = this.props.User.email;
        } 
        this.props.dispatch(PaypalPaidSuccess(send_ob, function(result) {
          if(result) {
            if(window.woopra != 'undefined') {
              window.woopra.track("payment", {
                amount: this.props.Paper.paper.doc_cost,
                currency: "USD"
              });
            }
            window.clickcease(this.props.Paper.paper.doc_cost);
            this.props.history.push('/thankyou/');
            window.scrollTo(0, 0);
          } else {
            console.log("there was a problem finalizing paypal purchase on our backend");
            // how do we issue a refund here?
          }
        }.bind(this)));
    }
    const onCancel = (data) => {
        console.log('The payment was cancelled!', data);
    }
    const onError = (err) => {
        console.log("Error!", err);
        // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
        // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
    }
    var upsell_time_limit_name;
    switch (this.props.Paper.paper.time_limit) {
      case '1.5':
        upsell_time_limit_name = '-';
        break;
      case '3':
        upsell_time_limit_name = '1.5';
        break;
      case '7':
        upsell_time_limit_name = '3';
        break;
      case '12':
        upsell_time_limit_name = '7';
        break;
      case '24':
        upsell_time_limit_name = '12';
        break;
      case '72':
        upsell_time_limit_name = '24';
        break;
      default:
        upsell_time_limit_name = '-';
        break;
    }
    var upsell_editor_name;
    switch (this.props.Paper.paper.editor_level) {
      case 'pro':
        upsell_editor_name = '-';
        break;
      case 'gold':
        upsell_editor_name = 'pro';
        break;
      case 'silver':
        upsell_editor_name = 'gold';
        break;
      case 'bronze':
        upsell_editor_name = 'silver';
        break;
      default:
    }
    var taxPer = 0.0;

    if (this.props.Paper.paper.country === "AB"){taxPer = 0.05;  }
    if (this.props.Paper.paper.country === "BC") {taxPer = 0.12;	}
    if (this.props.Paper.paper.country === "MB") {taxPer = 0.05;	}
    if (this.props.Paper.paper.country === "NB") {	taxPer = 0.13;	}
    if (this.props.Paper.paper.country === "NL") {	taxPer = 0.13;	}
    if (this.props.Paper.paper.country === "NT"){	taxPer = 0.05;	}
    if (this.props.Paper.paper.country === "NS"){	taxPer = 0.15;	}
    if (this.props.Paper.paper.country === "NU") {	taxPer = 0.05;	}
    if (this.props.Paper.paper.country === "ON") {	taxPer = 0.13;	}
    if (this.props.Paper.paper.country === "QC") {	taxPer = 0.05;	}
    if (this.props.Paper.paper.country === "PE") {	taxPer = 0.14;	}
    if (this.props.Paper.paper.country === "SK") {	taxPer = 0.05;	}
    if (this.props.Paper.paper.country === "YT") {	taxPer = 0.05;	}
    
    var basePrice = this.props.Paper.paper.doc_cost;
    if(this.props.Pay.coupon_amount && this.props.Pay.balanceUsed == 0) {
      basePrice = basePrice - this.props.Pay.coupon_amount;
    }
    var possibleBalance = 0;
    var cantUseBalance = true;
    if(this.props.User && this.props.User.loggedin && this.props.User.balance > 0) {
      var halfBasePrice = parseInt(basePrice*0.5);
      if(this.props.User.balance >= halfBasePrice) possibleBalance = halfBasePrice;
      else possibleBalance = this.props.User.balance;
      if(!this.props.Pay.coupon_code) {
        cantUseBalance = false;
      }
    }

    if(this.props.Pay.balanceUsed > 0 && !this.props.Pay.coupon_amount) {
      basePrice = basePrice - this.props.Pay.balanceUsed;
    }
    this.final_price = 0;
    this.final_price = +basePrice+ +(parseFloat((basePrice || 0) * taxPer).toFixed(2))
    this.final_price = parseFloat(this.final_price);
    this.taxValue = parseFloat((basePrice || 0) * taxPer).toFixed(2)

    var canUpgradeLevel = false;
    if(this.props.Paper.paper.editor_level != "pro" && 
        this.props.Paper.paper.upsold_price_level >= this.props.Paper.paper.extras_diff) {
          if(this.props.Paper.paper.time_limit > 7 && displayUtils.editorLessThanOrEqual(this.props.Paper.paper.editor_level, "gold")) {
            canUpgradeLevel = true;
          } else if (displayUtils.editorLessThan(this.props.Paper.paper.editor_level, "pro")) {
            canUpgradeLevel = true;
          }
    }

    // short variable name to make IF statements below shorter
    var tmpWC = this.props.Paper.paper.word_count;
    var canUpgradeTime = false;
    if((this.props.Paper.paper.time_limit != "1.5" && this.props.Paper.paper.upsold_price_time_limit >= this.props.Paper.paper.extras_diff)) {
      if (displayUtils.isTinyDocument(tmpWC) && this.props.Paper.paper.time_limit >= 3) {
        canUpgradeTime = true;
      }
      if (displayUtils.isSmallDocument(tmpWC) && this.props.Paper.paper.time_limit > 3) {
        canUpgradeTime = true;
      }
      if (displayUtils.isMediumDocument(tmpWC) && this.props.Paper.paper.time_limit > 7) {
        canUpgradeTime = true;
      }
      if (displayUtils.isLargeDocument(tmpWC) && this.props.Paper.paper.time_limit > 12) {
        canUpgradeTime = true;
      }
      if (displayUtils.isExtraLargeDocument(tmpWC) && this.props.Paper.paper.time_limit > 24) {
        canUpgradeTime = true;
      }
      if(this.props.Paper.paper.editor_level == "pro" && this.props.Paper.paper.time_limit == 12) {
        canUpgradeTime = false;
      }
    }

    return (
      <div>
        <Helmet>
          <title>Step 4 - Checkout | Edit My Paper </title>
          <meta name="description" content="Use Our Quick Submission Process for Easy Document Uploading and Professional Paper Editing."></meta>
        </Helmet>
      <ReactModal
         isOpen={this.props.Modals.extras_modal}
         contentLabel="Extras Step4 Modal"
         className="extras-modal"
      >
      <div className="modal-header">
        <div className="modal-header-text">Extras</div>
        <i className="fa fa-times faq-modal-close fa-2x" aria-hidden="true" onClick={this.closeExtraModal.bind(this)} value="Close"></i>
      </div>
      <Extras />
      </ReactModal>
      <ReactModal
         isOpen={this.props.Modals.terms_modal}
         contentLabel="Terms of Use"
         className="terms-modal"
        >
        <div className="modal-header">
          <div className="modal-header-text">Terms and Conditions</div>
          <i className="fa fa-times faq-modal-close fa-2x" aria-hidden="true" onClick={this.closeTermsModal.bind(this)} value="Close"></i>
        </div>
        <Terms/>
      </ReactModal>
      <ReactModal
         isOpen={this.state.paymentProcessing}
         contentLabel="Processing Payment"
         className="payment-processed-modal"
         style={{ overlay: {"zIndex": 300, "backgroundColor": "rgb(255, 255, 255, 1)"} }}
        >
        <div className="modal-header">
          <div className="modal-header-text">Processing Payment</div>
        </div>
        <div>
          The payment is being processed. Please hold on.
        </div>
      </ReactModal>
      <ReactModal
         isOpen={this.state.showCouponModal}
         contentLabel="Coupon Status"
         className="emp-dialog coupon-status-modal"
        >
        <div className="modal-header">
          <div className="modal-header-text">Coupon Verification</div>
        </div>
        <div>
          <span>{this.state.couponModalMsg}</span>
          <button className="button style1 modalbutton" onClick={this.closeCouponModal.bind(this)}>OK</button>
        </div>
      </ReactModal>
      <TopNav inSteps={true}/>
      <section className="steps top_section">
      <Bubbles currentStep={4}></Bubbles>
      <br/><br/><br/>
      </section>
      <section className="checkout">
        <div className="container">
          <div className="row">
            <div className="container-fluid">
              <div className="checkout_wrapper">
                <div className="top-heading text-center">
                  <h2>Your Editing Summary</h2>
                </div>
                <div className="mobile-only step4-edit-summary">
                  <div>File Name: {this.props.Paper.paper.doc_name.substring(0,30)+'...'    || 'none'}</div>
                  <div>Word Count: {this.props.Paper.paper.word_count || 'none'}</div>
                </div>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="desktop-only">File Name</th>
                        <th className="desktop-only">Word Count</th>
                        <th>Package</th>
                        <th>Turn Around Time</th>
                        <th className="desktop-only">Extras Added</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="desktop-only"><h3 className="file_name">{this.props.Paper.paper.doc_name.substring(0,30)+'...'    || 'none'}</h3></td>
                        <td className="desktop-only"><h4 className="file_words">{this.props.Paper.paper.word_count || 'none'}</h4></td>
                        <td>
                          <div className="wrap2">
                            <label >
                              <div className="trophy silver" onClick={this.upsellEditorLevel.bind(this,upsell_editor_name)}><i className="fa fa-trophy" aria-hidden="true"></i></div>
                              <h4 className="hours">{this.props.Paper.paper.editor_level} Editor</h4>
                              { console.log("going to show values ")}
                              {   console.log(this.props.Paper.paper.upsold_price_level) }
                              {   console.log(this.props.Paper.paper.extras_price) }
                              {   console.log(this.props.Paper.paper.doc_cost) }
                              {
                                (canUpgradeLevel) ?
                                <div>
                                  <button onClick={this.upsellEditorLevel.bind(this,upsell_editor_name)} className="button small gold">
                                  <span className="desktop-only">upgrade</span><i className="mobile-only fa fa-arrow-up"></i> to {upsell_editor_name} for ${this.props.Paper.paper.upsold_price_level+this.props.Paper.paper.extras_price || 'NA'}</button>
                                  <div className="small-undo" onClick={this.downsell_editor_level.bind(this)}>
                                    <svg width="20px" height="30px" viewBox="0 0 13 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g id="Step-4.1" transform="translate(-846.000000, -430.000000)">
                                                <g id="Group-31" transform="translate(846.000000, 431.000000)">
                                                    <path d="M6.57345381,14.4030231 C9.87611661,14.4030231 12.5534538,11.7398893 12.5534538,8.45474725 C12.5534538,5.1696052 9.87611661,2.50647139 6.57345381,2.50647139 C3.270791,2.50647139 0.864315396,5.18067202 0.593453807,8.45474725 C0.499587809,9.5893649 0.49759478,9.47720045 0.451427784,10.0161264 C0.366845538,11.0034889 0.593453812,8.45474725 0.593453812,8.45474725" id="Oval-1" stroke="#DA5757" transform="translate(6.492987, 8.454747) rotate(-275.000000) translate(-6.492987, -8.454747) "></path>
                                                    <g id="Group-29" transform="translate(3.640000, 0.000000)" stroke="#DA5757" strokeLinecap="square">
                                                        <path d="M2.86,0.25862069 L0.505599871,2.60053076" id="Line"></path>
                                                        <path d="M2.86,4.9137931 L0.508704436,2.5893965" id="Line"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <div onClick={this.downsell_editor_level.bind(this)}>Undo</div>
                                  </div>
                                  </div>
                              :
                                  <div>
                                    <button className="button small gold">Fully Upgraded!</button>
                                    <div className="small-undo" onClick={this.downsell_editor_level.bind(this)}>
                                      <svg width="20px" height="30px" viewBox="0 0 13 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="Step-4.1" transform="translate(-846.000000, -430.000000)">
                                          <g id="Group-31" transform="translate(846.000000, 431.000000)">
                                            <path d="M6.57345381,14.4030231 C9.87611661,14.4030231 12.5534538,11.7398893 12.5534538,8.45474725 C12.5534538,5.1696052 9.87611661,2.50647139 6.57345381,2.50647139 C3.270791,2.50647139 0.864315396,5.18067202 0.593453807,8.45474725 C0.499587809,9.5893649 0.49759478,9.47720045 0.451427784,10.0161264 C0.366845538,11.0034889 0.593453812,8.45474725 0.593453812,8.45474725" id="Oval-1" stroke="#DA5757" transform="translate(6.492987, 8.454747) rotate(-275.000000) translate(-6.492987, -8.454747) "></path>
                                            <g id="Group-29" transform="translate(3.640000, 0.000000)" stroke="#DA5757" strokeLinecap="square">
                                              <path d="M2.86,0.25862069 L0.505599871,2.60053076" id="Line"></path>
                                              <path d="M2.86,4.9137931 L0.508704436,2.5893965" id="Line"></path>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                    <div>Undo</div>
                                  </div>
                                </div>
                              }
                            </label>
                            </div>
                        </td>
                        <td>
                          <div className="wrap">
                            <label >
                              <i className="fa fa-clock-o fa-3x" aria-hidden="true"></i>
                              <h4 className="hours">{this.props.Paper.paper.time_limit} Hours</h4>
                              {(canUpgradeTime) ?
                              <div>
                                <button onClick={this.upsell_time_limit.bind(this,upsell_time_limit_name)} className="button small darkblue">
                                <span className="desktop-only">Upgrade</span><i className="mobile-only fa fa-arrow-up"></i> to {upsell_time_limit_name}<span className="desktop-only"> hours</span><span className="mobile-only">h</span> for ${this.props.Paper.paper.upsold_price_time_limit+this.props.Paper.paper.extras_price || 'NA'}</button>
                                  <div className="small-undo" onClick={this.downsell_time_limit.bind(this)}>
                                    <svg width="20px" height="30px" viewBox="0 0 13 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g id="Step-4.1" transform="translate(-846.000000, -430.000000)">
                                                <g id="Group-31" transform="translate(846.000000, 431.000000)">
                                                    <path d="M6.57345381,14.4030231 C9.87611661,14.4030231 12.5534538,11.7398893 12.5534538,8.45474725 C12.5534538,5.1696052 9.87611661,2.50647139 6.57345381,2.50647139 C3.270791,2.50647139 0.864315396,5.18067202 0.593453807,8.45474725 C0.499587809,9.5893649 0.49759478,9.47720045 0.451427784,10.0161264 C0.366845538,11.0034889 0.593453812,8.45474725 0.593453812,8.45474725" id="Oval-1" stroke="#DA5757" transform="translate(6.492987, 8.454747) rotate(-275.000000) translate(-6.492987, -8.454747) "></path>
                                                    <g id="Group-29" transform="translate(3.640000, 0.000000)" stroke="#DA5757" strokeLinecap="square">
                                                        <path d="M2.86,0.25862069 L0.505599871,2.60053076" id="Line"></path>
                                                        <path d="M2.86,4.9137931 L0.508704436,2.5893965" id="Line"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <div onClick={this.downsell_time_limit.bind(this)}>Undo</div>
                                  </div>
                              </div>
                              :
                                <div>
                                  <button className="button small gold">Fully Upgraded!</button>
                                  <div className="small-undo" onClick={this.downsell_time_limit.bind(this)}>
                                    <svg width="20px" height="20px" viewBox="0 0 13 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g id="Step-4.1" transform="translate(-846.000000, -430.000000)">
                                                <g id="Group-31" transform="translate(846.000000, 431.000000)">
                                                    <path d="M6.57345381,14.4030231 C9.87611661,14.4030231 12.5534538,11.7398893 12.5534538,8.45474725 C12.5534538,5.1696052 9.87611661,2.50647139 6.57345381,2.50647139 C3.270791,2.50647139 0.864315396,5.18067202 0.593453807,8.45474725 C0.499587809,9.5893649 0.49759478,9.47720045 0.451427784,10.0161264 C0.366845538,11.0034889 0.593453812,8.45474725 0.593453812,8.45474725" id="Oval-1" stroke="#DA5757" transform="translate(6.492987, 8.454747) rotate(-275.000000) translate(-6.492987, -8.454747) "></path>
                                                    <g id="Group-29" transform="translate(3.640000, 0.000000)" stroke="#DA5757" strokeLinecap="square">
                                                        <path d="M2.86,0.25862069 L0.505599871,2.60053076" id="Line"></path>
                                                        <path d="M2.86,4.9137931 L0.508704436,2.5893965" id="Line"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <div>Undo</div>
                                  </div>
                                </div>
                              }

                            </label>
                          </div>
                        </td>
                        <td className="desktop-only">
                        {this.getExtrasSummary()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="mobile-only step4-extras-mobile">
                  {this.getExtrasSummary()}
                </div>
                <div className="table_bottom_form">
                  <div className="form_wrapper row">
                          <div className="col-md-4 col-sm-6 col-xs-12">
                            <label>Email Address</label>
                            <div className="input-wrap check_status ">
                              <input className="full" style={this.getAcceptRequiredClasses('email')} {...this.emailFieldOpts} placeholder="email@email.com" type="text" onChange={this.validateEmail} value={this.props.User.email} />
                            </div>
                              <div className="input-wrap check_status">
                              <select className="countries-select" style={this.getAcceptRequiredClasses('state')} value={this.props.Paper.paper.country || ""} onChange={this.updatePaperInput.bind(this, 'country')}>
                                <option value="">Select your location</option>
                                <optgroup label="Canada">
                                  <option value="AB">Alberta</option>
                                  <option value="BC">British Columbia</option>
                                  <option value="MB">Manitoba</option>
                                  <option value="NB">New Brunswick</option>
                                  <option value="NL">Newfoundland and Labrador</option>
                                  <option value="NS">Nova Scotia</option>
                                  <option value="ON">Ontario</option>
                                  <option value="PE">Prince Edward Island</option>
                                  <option value="QC">Quebec</option>
                                  <option value="SK">Saskatchewan</option>
                                  <option value="NT">Northwest Territories</option>
                                  <option value="NU">Nunavut</option>
                                  <option value="YT">Yukon</option>
                                </optgroup>
                                <option value="US">United States</option>
                                <option value="GB">United Kingdom</option>
                                <option value="AF">Afghanistan</option>
                                <option value="AX">Åland Islands</option>
                                <option value="AL">Albania</option>
                                <option value="DZ">Algeria</option>
                                <option value="AS">American Samoa</option>
                                <option value="AD">Andorra</option>
                                <option value="AO">Angola</option>
                                <option value="AI">Anguilla</option>
                                <option value="AQ">Antarctica</option>
                                <option value="AG">Antigua and Barbuda</option>
                                <option value="AR">Argentina</option>
                                <option value="AM">Armenia</option>
                                <option value="AW">Aruba</option>
                                <option value="AU">Australia</option>
                                <option value="AT">Austria</option>
                                <option value="AZ">Azerbaijan</option>
                                <option value="BS">Bahamas</option>
                                <option value="BH">Bahrain</option>
                                <option value="BD">Bangladesh</option>
                                <option value="BB">Barbados</option>
                                <option value="BY">Belarus</option>
                                <option value="BE">Belgium</option>
                                <option value="BZ">Belize</option>
                                <option value="BJ">Benin</option>
                                <option value="BM">Bermuda</option>
                                <option value="BT">Bhutan</option>
                                <option value="BO">Bolivia, Plurinational State of</option>
                                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                                <option value="BA">Bosnia and Herzegovina</option>
                                <option value="BW">Botswana</option>
                                <option value="BV">Bouvet Island</option>
                                <option value="BR">Brazil</option>
                                <option value="IO">British Indian Ocean Territory</option>
                                <option value="BN">Brunei Darussalam</option>
                                <option value="BG">Bulgaria</option>
                                <option value="BF">Burkina Faso</option>
                                <option value="BI">Burundi</option>
                                <option value="KH">Cambodia</option>
                                <option value="CM">Cameroon</option>
                                <option value="CV">Cape Verde</option>
                                <option value="KY">Cayman Islands</option>
                                <option value="CF">Central African Republic</option>
                                <option value="TD">Chad</option>
                                <option value="CL">Chile</option>
                                <option value="CN">China</option>
                                <option value="CX">Christmas Island</option>
                                <option value="CC">Cocos (Keeling) Islands</option>
                                <option value="CO">Colombia</option>
                                <option value="KM">Comoros</option>
                                <option value="CG">Congo</option>
                                <option value="CD">Congo, the Democratic Republic of the</option>
                                <option value="CK">Cook Islands</option>
                                <option value="CR">Costa Rica</option>
                                <option value="CI">Côte dIvoire</option>
                                <option value="HR">Croatia</option>
                                <option value="CU">Cuba</option>
                                <option value="CW">Curaçao</option>
                                <option value="CY">Cyprus</option>
                                <option value="CZ">Czech Republic</option>
                                <option value="DK">Denmark</option>
                                <option value="DJ">Djibouti</option>
                                <option value="DM">Dominica</option>
                                <option value="DO">Dominican Republic</option>
                                <option value="EC">Ecuador</option>
                                <option value="EG">Egypt</option>
                                <option value="SV">El Salvador</option>
                                <option value="GQ">Equatorial Guinea</option>
                                <option value="ER">Eritrea</option>
                                <option value="EE">Estonia</option>
                                <option value="ET">Ethiopia</option>
                                <option value="FK">Falkland Islands (Malvinas)</option>
                                <option value="FO">Faroe Islands</option>
                                <option value="FJ">Fiji</option>
                                <option value="FI">Finland</option>
                                <option value="FR">France</option>
                                <option value="GF">French Guiana</option>
                                <option value="PF">French Polynesia</option>
                                <option value="TF">French Southern Territories</option>
                                <option value="GA">Gabon</option>
                                <option value="GM">Gambia</option>
                                <option value="GE">Georgia</option>
                                <option value="DE">Germany</option>
                                <option value="GH">Ghana</option>
                                <option value="GI">Gibraltar</option>
                                <option value="GR">Greece</option>
                                <option value="GL">Greenland</option>
                                <option value="GD">Grenada</option>
                                <option value="GP">Guadeloupe</option>
                                <option value="GU">Guam</option>
                                <option value="GT">Guatemala</option>
                                <option value="GG">Guernsey</option>
                                <option value="GN">Guinea</option>
                                <option value="GW">Guinea-Bissau</option>
                                <option value="GY">Guyana</option>
                                <option value="HT">Haiti</option>
                                <option value="HM">Heard Island and McDonald Islands</option>
                                <option value="VA">Holy See (Vatican City State)</option>
                                <option value="HN">Honduras</option>
                                <option value="HK">Hong Kong</option>
                                <option value="HU">Hungary</option>
                                <option value="IS">Iceland</option>
                                <option value="IN">India</option>
                                <option value="ID">Indonesia</option>
                                <option value="IR">Iran, Islamic Republic of</option>
                                <option value="IQ">Iraq</option>
                                <option value="IE">Ireland</option>
                                <option value="IM">Isle of Man</option>
                                <option value="IL">Israel</option>
                                <option value="IT">Italy</option>
                                <option value="JM">Jamaica</option>
                                <option value="JP">Japan</option>
                                <option value="JE">Jersey</option>
                                <option value="JO">Jordan</option>
                                <option value="KZ">Kazakhstan</option>
                                <option value="KE">Kenya</option>
                                <option value="KI">Kiribati</option>
                                <option value="KP">Korea, Democratic Peoples Republic of</option>
                                <option value="KR">Korea, Republic of</option>
                                <option value="KW">Kuwait</option>
                                <option value="KG">Kyrgyzstan</option>
                                <option value="LA">Lao Peoples Democratic Republic</option>
                                <option value="LV">Latvia</option>
                                <option value="LB">Lebanon</option>
                                <option value="LS">Lesotho</option>
                                <option value="LR">Liberia</option>
                                <option value="LY">Libya</option>
                                <option value="LI">Liechtenstein</option>
                                <option value="LT">Lithuania</option>
                                <option value="LU">Luxembourg</option>
                                <option value="MO">Macao</option>
                                <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                                <option value="MG">Madagascar</option>
                                <option value="MW">Malawi</option>
                                <option value="MY">Malaysia</option>
                                <option value="MV">Maldives</option>
                                <option value="ML">Mali</option>
                                <option value="MT">Malta</option>
                                <option value="MH">Marshall Islands</option>
                                <option value="MQ">Martinique</option>
                                <option value="MR">Mauritania</option>
                                <option value="MU">Mauritius</option>
                                <option value="YT">Mayotte</option>
                                <option value="MX">Mexico</option>
                                <option value="FM">Micronesia, Federated States of</option>
                                <option value="MD">Moldova, Republic of</option>
                                <option value="MC">Monaco</option>
                                <option value="MN">Mongolia</option>
                                <option value="ME">Montenegro</option>
                                <option value="MS">Montserrat</option>
                                <option value="MA">Morocco</option>
                                <option value="MZ">Mozambique</option>
                                <option value="MM">Myanmar</option>
                                <option value="NA">Namibia</option>
                                <option value="NR">Nauru</option>
                                <option value="NP">Nepal</option>
                                <option value="NL">Netherlands</option>
                                <option value="NC">New Caledonia</option>
                                <option value="NZ">New Zealand</option>
                                <option value="NI">Nicaragua</option>
                                <option value="NE">Niger</option>
                                <option value="NG">Nigeria</option>
                                <option value="NU">Niue</option>
                                <option value="NF">Norfolk Island</option>
                                <option value="MP">Northern Mariana Islands</option>
                                <option value="NO">Norway</option>
                                <option value="OM">Oman</option>
                                <option value="PK">Pakistan</option>
                                <option value="PW">Palau</option>
                                <option value="PS">Palestinian Territory, Occupied</option>
                                <option value="PA">Panama</option>
                                <option value="PG">Papua New Guinea</option>
                                <option value="PY">Paraguay</option>
                                <option value="PE">Peru</option>
                                <option value="PH">Philippines</option>
                                <option value="PN">Pitcairn</option>
                                <option value="PL">Poland</option>
                                <option value="PT">Portugal</option>
                                <option value="PR">Puerto Rico</option>
                                <option value="QA">Qatar</option>
                                <option value="RE">Réunion</option>
                                <option value="RO">Romania</option>
                                <option value="RU">Russian Federation</option>
                                <option value="RW">Rwanda</option>
                                <option value="BL">Saint Barthélemy</option>
                                <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                                <option value="KN">Saint Kitts and Nevis</option>
                                <option value="LC">Saint Lucia</option>
                                <option value="MF">Saint Martin (French part)</option>
                                <option value="PM">Saint Pierre and Miquelon</option>
                                <option value="VC">Saint Vincent and the Grenadines</option>
                                <option value="WS">Samoa</option>
                                <option value="SM">San Marino</option>
                                <option value="ST">Sao Tome and Principe</option>
                                <option value="SA">Saudi Arabia</option>
                                <option value="SN">Senegal</option>
                                <option value="RS">Serbia</option>
                                <option value="SC">Seychelles</option>
                                <option value="SL">Sierra Leone</option>
                                <option value="SG">Singapore</option>
                                <option value="SX">Sint Maarten (Dutch part)</option>
                                <option value="SK">Slovakia</option>
                                <option value="SI">Slovenia</option>
                                <option value="SB">Solomon Islands</option>
                                <option value="SO">Somalia</option>
                                <option value="ZA">South Africa</option>
                                <option value="GS">South Georgia and the South Sandwich Islands</option>
                                <option value="SS">South Sudan</option>
                                <option value="ES">Spain</option>
                                <option value="LK">Sri Lanka</option>
                                <option value="SD">Sudan</option>
                                <option value="SR">Suriname</option>
                                <option value="SJ">Svalbard and Jan Mayen</option>
                                <option value="SZ">Swaziland</option>
                                <option value="SE">Sweden</option>
                                <option value="CH">Switzerland</option>
                                <option value="SY">Syrian Arab Republic</option>
                                <option value="TW">Taiwan</option>
                                <option value="TJ">Tajikistan</option>
                                <option value="TZ">Tanzania, United Republic of</option>
                                <option value="TH">Thailand</option>
                                <option value="TL">Timor-Leste</option>
                                <option value="TG">Togo</option>
                                <option value="TK">Tokelau</option>
                                <option value="TO">Tonga</option>
                                <option value="TT">Trinidad and Tobago</option>
                                <option value="TN">Tunisia</option>
                                <option value="TR">Turkey</option>
                                <option value="TM">Turkmenistan</option>
                                <option value="TC">Turks and Caicos Islands</option>
                                <option value="TV">Tuvalu</option>
                                <option value="UG">Uganda</option>
                                <option value="UA">Ukraine</option>
                                <option value="AE">United Arab Emirates</option>
                                <option value="GB">United Kingdom</option>
                                <option value="US">United States</option>
                                <option value="UM">United States Minor Outlying Islands</option>
                                <option value="UY">Uruguay</option>
                                <option value="UZ">Uzbekistan</option>
                                <option value="VU">Vanuatu</option>
                                <option value="VE">Venezuela, Bolivarian Republic of</option>
                                <option value="VN">Viet Nam</option>
                                <option value="VG">Virgin Islands, British</option>
                                <option value="VI">Virgin Islands, U.S.</option>
                                <option value="WF">Wallis and Futuna</option>
                                <option value="EH">Western Sahara</option>
                                <option value="YE">Yemen</option>
                                <option value="ZM">Zambia</option>
                                <option value="ZW">Zimbabwe</option></select>
                              </div>
                              <div className="input-wrap check_status">
                                <input className="full" style={this.getAcceptRequiredClasses('address')}  placeholder="Street # + Street Name (address)" type="text"  onChange={this.updatePaperInput.bind(this, 'address')}/>
                              </div>
                              <div className="input-wrap check_status">
                                <input style={this.getAcceptRequiredClasses('zip')}  className="full" placeholder="Zip/Postal Code" type="text" onChange={this.updatePaperInput.bind(this, 'zip_code')} />
                              </div>
                              <p className="vat">
                                <span className="pull-right vat_info">HST: ${this.taxValue || 0.00}</span>
                              </p>
                              {(this.props.User && this.props.User.loggedin)?
                                  <div className={(cantUseBalance)? 'useBalance nobalance': 'useBalance'}>
                                    <input type="checkbox" disabled={cantUseBalance} onChange={this.updateUsingBalance.bind(this, possibleBalance)} value={this.state.usingBalance} /> Use ${possibleBalance} off my balance
                                  </div>
                                :<div></div>
                              }
                                <div className="coupan_code">
                                  <label>Code:</label>
                                  <div className="input-wrap coupan_code_wrap">
                                    <input onChange={this.updateCouponCode.bind(this)} value={this.props.Pay.coupon_code} className="full custom_coupan_code" type="text" disabled={this.state.usingBalance} />
                                    <button disabled={this.state.usingBalance} className="button style1 couponapplybutton" onClick={this.CheckCoupon.bind(this)}>Apply</button>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 col-xs-12">
                              <div className="price_counter">
                              <br/><br/><br/>
                                {
                                  ((!this.props.Pay.fullAddress) || (!this.props.Pay.terms_accepted) || (!this.props.Pay.emails_match)) ?
                                  <div className="pay-stopper">Please accept our terms of service and confirm your email to pay.</div>
                                  :
                                  <div className="price_counter_wrapper">
                                  {this.timeoutPaypal()}
                                  <StripeCheckout
                                      name="Edit My Paper"
                                      description="Essay Editing Done Right!"
                                      image=""
                                      ComponentClass="div"
                                      panelLabel="Pay"
                                      amount={this.final_price * 100}
                                      currency="USD"
                                      stripeKey={this.stripeKeys[this.stripeEnv]}
                                      locale="auto"
                                      email=""
                                      allowRememberMe
                                      token={this.onStripeToken}
                                      closed={this.onStripeClosed.bind(this)}
                                      reconfigureOnUpdate={false}
                                      triggerEvent="onClick"
                                      >
                                    </StripeCheckout>
                                    {(this.state.showStripeCustomErrorMessage)? 
                                      <span className="stripe-failed"><br />We cannot process the transaction with your card.<br/>Please use another card or use PayPal.</span>
                                    :
                                      <span></span>
                                    }
                                    <br/><br />
                                    <label>
                                      {(this.state.paypalAvailable) && 
                                      <PaypalExpressBtn 
                                        env={paypalEnv} 
                                        disabled 
                                        client={client} 
                                        currency={'USD'} 
                                        total={this.final_price} 
                                        onSuccess={onSuccess} 
                                        style={{'color': 'blue', 'shape': 'rect', 'tagline': false, 'label': 'pay'}}>
                                      </PaypalExpressBtn>}
                                    </label>
                                  </div>
                                }
                              </div>
                            </div>

                            <div className="col-md-4 col-sm-6 col-xs-12">
                              <div className="price_counter">
                                <div className="price_counter_wrapper">
                                  <div className="step4DocCost">
                                    <span>Total Price: ${this.props.Paper.paper.doc_cost}</span>
                                    {(this.state.usingBalance || this.props.Pay.coupon_amount)?
                                      <span>Discount: ${(this.state.usingBalance)? this.props.Pay.balanceUsed: this.props.Pay.coupon_amount}</span>
                                      :
                                      <span></span>
                                    }
                                    <span>Tax: ${this.taxValue}</span>
                                  </div>
                                  <div className="package">
                                    <p className="package_time">You Pay:</p>
                                  </div>
                                  <div className="price">
                                    <p className="price_details">${this.final_price || 0.00}</p>
                                  </div>
                                </div>
                                <div className="summary-wrapper">Your paper will be edited by a <b>{this.props.Paper.paper.editor_level}</b> level editor and returned within <b>{this.props.Paper.paper.time_limit}</b> hours via email and be available for download in your account.</div>
                                <div className="tos-checkbox" style={{'fontSize': '18px'}}>
                                  <label><input style={this.getAcceptRequiredClasses('terms')} value="terms" type="checkbox" checked={this.props.Pay.terms_accepted} onClick={this.TermsAreChecked.bind(this)} />I have read and agree to the <span onClick={this.openTermsModal.bind(this)} style={{'color': '#1076ee'}}>terms of service.</span></label>
                                </div>
                              </div>
                            </div>

                            
                    </div>
                </div>
              </div>
              <div className="text-center checkout_bottom_wrapper">
                <div className="button_wrapper button_center">
                <Link to="/step3" className="button back">
                  <svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                          <g id="Step-2.1A-FAQ" transform="translate(-200.000000, -945.000000)" stroke="#419BF9">
                              <g id="Group-9" transform="translate(188.000000, 936.000000)">
                                  <g id="Group-16" transform="translate(0.857143, 0.000000)">
                                      <g id="Group-16-Copy" transform="translate(47.000000, 13.500000) scale(1, -1) translate(-47.000000, -13.500000) ">
                                          <path d="M12.4229503,17.2913356 L16.5101983,13.2040874" id="Line" transform="translate(14.785714, 15.500000) scale(1, -1) translate(-14.785714, -15.500000) "></path>
                                          <path d="M12.4229503,13.2913356 L16.5101983,9.20408739" id="Line"></path>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </svg> back
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
      </div>
    )
  }
}

export default connect(
  ({Paper, User, Modals, Pay})=>({Paper, User, Modals, Pay})
)(Step4Page);

let checkout_style = {
    background: "#167be2",
    width: "150px"
}



// WEBPACK FOOTER //
// ./src/components/steps/step4.js